<body>
    <div class="alert alert-danger" role="alert" *ngIf="!success">
        {{message}}
      </div>
      <div class="alert alert-success" role="alert" *ngIf="success">
        {{message}}
      </div>
</body>